import React from "react";
import ButtonLink from "../ButtonLink";

const getPercentageUsedColor = (percentageUsed) => {
	if (percentageUsed < 50) {
		return "var(--lxw-main-500)";
	} else if (percentageUsed < 80) {
		return "orange";
	} else {
		return "red";
	}
};

const parseAndReturnDataUsageString = (dataUsageCalculationTime) => {
	if (!dataUsageCalculationTime) {
		return "N/A";
	}
	const dataUsageCalculationTimeDateObject = new Date(
		dataUsageCalculationTime.replace(
			/^(\d{4}-\d{2}-\d{2})-(\d{2})-(\d{2})$/,
			"$1T$2:$3"
		)
	);
	return dataUsageCalculationTimeDateObject.toLocaleString(undefined, {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		hour12: true,
		timeZoneName: "shortGeneric",
	});
};

const StorageDetails = ({
	standardSizeHuman,
	archivedSizeHuman,
	standardDataLimitHuman,
	archivedDataLimitHuman,
	dataUsageCalculationTime,
	ocrLimit,
	ocrUsage,
	canRequestMonthlyOCRLimitIncrease,
	increaseMonthlyOCR,
}) => {
	const dataUsageCalculationTimeString = parseAndReturnDataUsageString(
		dataUsageCalculationTime
	);
	return (
		<div>
			<div>
				<div className="MainFontBold">Data Usage</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "8px",
						margin: 8,
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<strong>Last Calculated:</strong>{" "}
						{dataUsageCalculationTimeString}
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<strong>Current Standard Usage:</strong>{" "}
						{standardSizeHuman} of {standardDataLimitHuman} used
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<strong>Current Archive Usage:</strong>{" "}
						{archivedSizeHuman} of {archivedDataLimitHuman} used
					</div>
				</div>
			</div>
			<div>
				<div className="MainFontBold">OCR Usage</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "8px",
						margin: 8,
					}}
				>
					<div>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "space-between",
							}}
						>
							<strong>Current OCR Usage:</strong> {ocrUsage} of{" "}
							{ocrLimit} used
						</div>
						{canRequestMonthlyOCRLimitIncrease && (
							<div style={{ justifySelf: "end" }}>
								<ButtonLink
									onClick={() => increaseMonthlyOCR()}
								>
									Increase Limit
								</ButtonLink>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export {
	StorageDetails,
	parseAndReturnDataUsageString,
	getPercentageUsedColor,
};
